import AnalyticsService from '@forwardflow/services/AnalyticsService'
import useSWR from 'swr'

export default function useGetAnalyticsData() {
   const response = useSWR('/marketing-analytics', () =>
      AnalyticsService.getAnalyticsData()
   )
   return {
      ...response,
   }
}
